import React from 'react';
import { Card, CardContent, Typography, CardHeader, CardActions, Tooltip, Box } from '@mui/material';
import { Violation, ViolationStage } from '../../Types/UnitFeatureTypes';
import { Circle } from '@mui/icons-material';
import Editor from '../TextEditor/Editor';


const DisplayViolationCard: React.FC<{ item: Violation }> = ({ item }) => {

    const getViolationStageColor = (stage: ViolationStage) => {
        switch (stage) {
            case ViolationStage.FIRST_VIOLATION:
                return '#FCB15A';
            case ViolationStage.VERBAL_WARNING:
                return '#ffffc5';
            case ViolationStage.WRITTEN_WARNING:
                return '#fc585d';
            case ViolationStage.FINE:
                return '#BF77F6';
            default:
                return '#B0BEC5';
        }
    };

    interface RichTextChild {
        text?: string;
        children?: RichTextChild[];
    }

    interface RichTextRoot {
        children: RichTextChild[];
    }

    interface RichTextJSON {
        root: RichTextRoot;
    }

    const violationStageColor = getViolationStageColor(item.stage);
    return (
        <Tooltip title={<><b>Priority: </b> <b style={{color: violationStageColor}}>{item.stage}</b></>}>
            <Card sx={{ maxWidth: 240, borderRadius: 3, minHeight: 200, borderLeft: `5px solid ${violationStageColor}` }}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Tooltip title={item.title}>
                        <CardHeader title={item.title}  subheader={<Typography variant="body2" color="textSecondary"> Created on {new Date(item.created_on).toDateString()}</Typography>} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} />
                    </Tooltip>
                    <Circle sx={{color: violationStageColor, mr: 2, fontSize: 20}} />
                </Box>                                
                <CardContent>
                    <Typography variant="body2" color="textSecondary">
                        Possible Penalties: {item.possible_penalties}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Typography variant="body2" color="textSecondary">
                        Due date {new Date(item.possible_penalties).toDateString()}
                    </Typography>
                </CardActions>
            </Card>
        </Tooltip>
    );
}

export default DisplayViolationCard;